var _line, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 200,
    viewBox: "0 0 46 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: -9.83506e-7,
    x2: 22.5,
    y2: 200,
    stroke: "url(#paint0_linear_1_8)",
    strokeWidth: 45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5235 158L3.05394 141.203L41.9931 141.203L22.5235 158Z",
    fill: "url(#paint1_linear_1_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5421 144.198L3.07251 127.4L42.0116 127.4L22.5421 144.198Z",
    fill: "url(#paint2_linear_1_8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5606 130.396L3.09109 113.599L42.0302 113.599L22.5606 130.396Z",
    fill: "url(#paint3_linear_1_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8",
    x1: -8.5,
    y1: 325.904,
    x2: 3.83302,
    y2: 0.145116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70A0D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_8",
    x1: 22.5235,
    y1: 158,
    x2: 22.5235,
    y2: 135.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_8",
    x1: 22.5421,
    y1: 144.198,
    x2: 22.5421,
    y2: 121.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_8",
    x1: 22.5606,
    y1: 130.396,
    x2: 22.5606,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe1);
export default __webpack_public_path__ + "static/media/pipe-1.80e36b129e029a5dcce73fba9afa1342.svg";
export { ForwardRef as ReactComponent };